
import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2BuddyEvent } from "../../../event/Poker2BuddyEvent";
import { Poker2GiveChipsEvent } from "../../../event/Poker2GiveChipsEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2StandardOkDialog } from "../../../view/dialogs/Poker2StandardOkDialog";
import { Poker2LayoutManager } from "../../../view/Poker2LayoutManager";
import { Poker2Command } from "../Poker2Command";

export class VGCCommand extends Poker2Command {
    protected get cmdId(): string {
        return "vgc";
    }
    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any;
            if (params[1]) {
                paramObj = JSON.parse(params[1]);
            }

            if (paramObj && "fromIndex" in paramObj && "toIndex" in paramObj) {
                var amount: number = parseFloat(paramObj.amount);
                var fromIndex: number = parseInt(paramObj.fromIndex);
                var toIndex: number = parseInt(paramObj.toIndex);
                this.controller.dispatchEvent(new Poker2BuddyEvent("givechips", [fromIndex, toIndex, amount]));
            }
            else {
                // show chips given confirmation dialog not while sitting at the table!
                if (Poker2LayoutManager.getInstance().currentState != 10) {
                    this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(
                        Poker2Model.languageData.getTextById("alert_chips_send_title"),
                        Poker2Model.languageData.getTextById("alert_chips_send_copy_ok")));
                }

                this.controller.dispatchEvent(new Poker2GiveChipsEvent("chipsSentSuccess", [Poker2Model.languageData.getTextById("alert_chips_send_title"), Poker2Model.languageData.getTextById("alert_chips_send_copy_ok")]));
            }
            return true;
        }
        else
            if (error == 108) {
                this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(
                    Poker2Model.languageData.getTextById("alert_chips_send_title"),
                    Poker2Model.languageData.getTextById("alert_chips_send_copy_error")));
                return false;
            }
            else
                return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
